export default {
  userLesson: state => uuid => {
    return state.userLessons.find(t=> t.uuid === uuid)
  },
}
